var render, staticRenderFns
import script from "./CrtDonation.vue?vue&type=script&lang=js&"
export * from "./CrtDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb1cb4d')) {
      api.createRecord('0cb1cb4d', component.options)
    } else {
      api.reload('0cb1cb4d', component.options)
    }
    
  }
}
component.options.__file = "src/views/Configuration/Donation/CrtDonation.vue"
export default component.exports